import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes';

const AgreementSentSummary = ({ partner }) => (
    <StatusSummaryButton
        href="/avtale-sendt"
        statusSummary="Du har sendt et avtaleforslag."
    >
        Venter på svar fra {partner.name}
    </StatusSummaryButton>
);

AgreementSentSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default AgreementSentSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/summaries/agreementSentSummary.jsx